'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SIMPLE = exports.SIMPLE = 'SIMPLE';
var EMAIL = exports.EMAIL = 'EMAIL';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/contentTypes.js
// module id = 368
// module chunks = 2 3